export default __webpack_public_path__ + "static/media/CNo.58-3.cc7fd3a9.jpg";